import { render, staticRenderFns } from "./accordion.vue?vue&type=template&id=7bc4f64c"
import script from "./accordion.vue?vue&type=script&lang=js"
export * from "./accordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johnmartin/Repos/whitefox-shopify-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bc4f64c')) {
      api.createRecord('7bc4f64c', component.options)
    } else {
      api.reload('7bc4f64c', component.options)
    }
    module.hot.accept("./accordion.vue?vue&type=template&id=7bc4f64c", function () {
      api.rerender('7bc4f64c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/accordion.vue"
export default component.exports